
import Vue from 'vue'

export default Vue.extend({
   props: {
      id: String,
      label: String,
      value: [String, Number, Boolean],
      options: Array as () => NameValuePair[],
      placeholder: { type: String, default: 'Choose...' },
      placeholderValue: { type: String, default: '### Choose ###' },
      required: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false },
      showLabel: { type: Boolean, default: true },
   },
   data() {
      return {
         initialValue: '' as string | number | boolean | null,
         innerValue: '' as string | number | boolean | null,
         dirty: false,
      }
   },
   computed: {
      innerOptions(): NameValuePair[] {
         if (this.placeholder) {
            return [{ name: this.placeholder, value: this.placeholderValue }, ...this.options]
         }
         return this.options
      },
      validationFailed(): boolean {
         if (!this.dirty) {
            return false
         }
         if (!this.required) {
            return false
         }
         return !this.innerValue
      },
      helpBlock(): string {
         return `A value for ${this.label} is required`
      },
   },
   mounted() {
      this.setInitialAndInnerValues(this.value)
   },
   watch: {
      value(newValue) {
         if (newValue !== this.initialValue) {
            this.setInitialAndInnerValues(this.value)
         }
      },
   },
   methods: {
      setInitialAndInnerValues(value: string | null | number | boolean) {
         let validValue = value
         if (
            this.placeholder.length > 0 &&
            (value === null || value === undefined || value === '')
         ) {
            validValue = this.placeholderValue
         }
         this.initialValue = validValue
         this.innerValue = validValue
      },
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.initialValue
         }
         const valueToEmit = this.innerValue === this.placeholderValue ? '' : this.innerValue
         this.$emit('input', valueToEmit)
         this.$emit('change', valueToEmit)
      },
   },
})
